<template>
  <div
    id="booking-verify"
    class="app-main-content"
  >
    <verify-tree-grid
      v-show="view==='list'"
      ref="verifyTreeGrid"
      :context="context"
      :use-order-center-mode="useOrderCenterMode"
      :order-center-branch="useOrderCenterBranch"
      :approve-cooperation-business="approveCooperationBusiness"
      @look="lookHandle"
      @edit="editHandle"
      @add="addHandle"
      @copy="copyHandle"
      @refresh="refreshHandle"
    />
    <verify-workspace
      v-show="view==='detail'"
      ref="verifyWorkspace"
      :parent-context="context"
      :use-order-center-mode="useOrderCenterMode"
      :approve-cooperation-business="approveCooperationBusiness"
      @add="addHandle"
      @copy="copyHandle"
      @back="backToList"
      @refresh="refreshHandle"
    />
    <job-no-rule-selector
      ref="jobNoRuleSelector"
      :visible.sync="jobNoRule.visible"
      :rules="jobNoRule.rules || []"
      @selectedBack="action === 'add' ? doAddJob : doCopyJob"
    />
  </div>
</template>

<script>
import { BookingVerifyContext } from './components/verify/bookingVerifyContext'
import jobNoRuleSelector from '@/components/Cargo/Job/jobNoRuleSelector'
import verifyTreeGrid from './components/verify/verifyTreeGrid'
import verifyWorkspace from './components/verify/verifyWorkspace'
import { ErrorTip } from '@/utils/class/ErrorTip'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { queryJobNoRule, isContractExpiredForbidCreateJob } from '@/api/seaExport/seaExportJob'
import { advancedQuery, doCopyJob, findAirExportJobByNo } from '@/api/AirExport/airExportJob'
import { getLoading } from '@/utils/utilBaseElement'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { JumpUtil } from '@/utils/JumpUtil'
import AdvancedSearchConsts from '@/class/cargo/model/parameters/OperatorConstants'

export default {
  name: 'AeBookingVerify',
  components: { verifyTreeGrid, verifyWorkspace, jobNoRuleSelector },
  data() {
    return {
      loading: null,
      context: BookingVerifyContext.getInstance(),
      view: 'list',
      job: null, // 复制使用
      jobNoRule: {
        visible: false,
        action: 'add',
        rules: ''
      }
    }
  },
  computed: {
    officeId() {
      return this.$store.getters.currentOfficeId
    },
    office() {
      return this.context.office
    },
    useOrderCenterMode() { // 是否开启接单中心模式
      return this.context.config ? Number(this.context.config.get('useOrderCenterMode')) === 1 : false
    },
    useOrderCenterBranch() { // 是否开启接单分公司
      return this.context.config ? Number(this.context.config.get('orderCenterBranch')) === 1 : false
    },
    approveCooperationBusiness() { // 是否协作分公司需审核接单分公司的协作业务
      return this.context.config ? Number(this.context.config.get('approveCooperationBusiness')) === 1 : false
    }
  },
  watch: {
    officeId: {
      async handler(newVal) {
        if (this.office.officeId !== this.officeId) {
          await this.context.prepareData()
        }
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      // 首页跳转
      if (to.query.jobNo && to.query.currentOfficeId) {
        vm.toDetailSop(vm, to.query.jobNo)
        return
      }
      // 如果此处需要用到生命周期created内初始化的数据，可能会导致报错
      if (to.query.jobNo) {
        vm.toDetail(vm, to.query.jobNo)
      }
    })
  },
  created() {
    this.context.prepareData()
  },
  activated() {
    if (this.$route.params.jobNos) {
      const filter = {
        conditions: [
          new AdvancedSearchOption(null, 'job.JOB_STATE', SystemConstants.STATE_VERIFYING.code).formatObj2Json()
        ]
      }
      JumpUtil.jumpToTab(advancedQuery, filter, this.$route.params, this, 'verifyWorkspace')
    }
  },
  errorCaptured(err) {
    if (err instanceof ErrorTip) {
      this.$message({ message: err.message, type: err.type })
      return false
    }
    return true
  },
  methods: {

    // 查询job后跳转详情
    toDetail(vm, jobNo) {
      const params = {}
      params.branchId = vm.$store.getters.currentOfficeId
      params.jobNo = jobNo
      params.pageNum = 1
      vm.view = 'detail'
      findAirExportJobByNo(params).then(res => {
        const rowData = res.data.list
        if (rowData) {
          const index = rowData.findIndex(p => p.jobNo === jobNo)
          if (index > 0) {
            vm.$refs.verifyWorkspace.onShow('look', rowData, rowData[index])
          } else {
            vm.$refs.verifyWorkspace.onShow('look', rowData, rowData[0])
          }
        }
      }).catch(() => {
        vm.$message.error(this.$t('Message.JumpFailed'))
      })
    },
    lookHandle(row) {
      this.detailHandle('look', row)
    },
    editHandle(row) {
      this.detailHandle('edit', row)
    },
    addHandle() {
      if (!this.checkOfficeId()) return
      this.confirmCallBackHandler('add')
    },
    checkOfficeId() {
      if (!this.office) {
        this.$message.warning(this.$t('Message.CurrentBranchIsNotSelectedCannotAddNewBookings'))
        return false
      }
      if (this.office.officeId === 1) {
        this.$message.warning(this.$t('Message.CompanySelectedIsHQCannotAddNewBookings'))
        return false
      }
      return true
    },
    backToList(isRefresh) {
      const rowData = this.$refs.verifyWorkspace.rowData
      this.view = 'list'
      if (isRefresh) {
        this.$refs.verifyTreeGrid.toQuery(rowData)
      }
    },
    // 复制
    copyHandle(row) {
      if (!row) return
      this.job = row
      if (row.customerId) {
        isContractExpiredForbidCreateJob(row.customerId).then(res => {
          if (res && res.data) {
            this.$message.warning(this.$t('Message.ContractExpireCannotCreated'))
            return
          } else {
            this.confirmCallBackHandler('copy')
          }
        })
      }
    },
    async confirmCallBackHandler(action) {
      await this.context.prepareData()
      if (action === 'copy') { // 复制
        this.doCopyJob()
      } else { // 新增
        this.loading = getLoading()
        if (String(this.context.config.get('UseNewJobNoRule')) === '1') {
          queryJobNoRule(SystemConstants.AE.code).then(res => {
            this.loading.close()
            this.ruleResultHandler(res, action)
          })
        } else {
          this.doAddJob()
        }
      }
    },
    doCopyJob(jobNoRule) {
      const item = {}
      item.jobRule = !jobNoRule ? '' : jobNoRule.uuid
      item.jobUuid = this.job.uuid
      item.branchId = this.$store.getters.currentOfficeId
      item.copyNum = 1
      item.all = false
      item.source = 'aeBookingVerify'
      this.loading = getLoading()
      doCopyJob(item).then(async res => {
        this.loading.close()
        const newJob = res.data
        // CARGO-18534 ID：5616 冠业 空运出口-订单预审希望新版本你能够参考老版本复制
        newJob.chargeWeight = 0
        newJob.quantityBooking = 0
        newJob.weightBooking = 0
        newJob.cubageBooking = 0
        newJob.chargeWeightBooking = 0
        newJob.quantityActual = 0
        newJob.weightActual = 0
        newJob.cubageActual = 0
        newJob.cWeight = 0
        newJob.chargeWeightImperial = 0
        newJob.weightBookingImperial = 0
        newJob.cubAgeBookingImperial = 0
        newJob.chargeWeightBookingImperial = 0
        newJob.weightActualImperial = 0
        newJob.cubAgeActualImperial = 0
        newJob.cWeightImperial = 0
        const continueExec = await JobUtils.validateJobFieldActive(newJob, this, 'AeBookingVerify')
        if (!continueExec) {
          return
        }
        this.detailHandle('copy', newJob)
      })
    },
    ruleResultHandler(event, action) {
      const rules = event.data
      if (rules && rules.length > 1) {
        this.jobNoRule.rules = rules
        this.jobNoRule.action = action
        this.jobNoRule.visible = true
      } else if (rules && rules.length > 0) {
        action === 'copy' ? this.doCopyJob(rules[0]) : this.doAddJob(rules[0])
      } else {
        this.$message.warning(this.$t('SeaExport.MaintainJobNoRule'))
        return
      }
    },
    doAddJob(jobNoRule) {
      this.detailHandle('add', { jobNoRule: !jobNoRule ? '' : jobNoRule.uuid })
    },
    // 进详情公共
    detailHandle(type, row) {
      let rowData = null
      if (this.view === 'detail') {
        rowData = this.$refs.verifyWorkspace.rowData
      } else {
        this.view = 'detail'
        rowData = this.$refs.verifyTreeGrid.rowData
      }
      this.$refs.verifyWorkspace.onShow(type, rowData, row)
    },
    splitHandle(row) {
      this.detailHandle('split', row)
    },
    // 操作成功后刷新详情
    refreshHandle(row) {
      row.isCompleteRow = false
      this.detailHandle('look', row)
    },
    // 首页查询job后跳转详情
    toDetailSop(vm, jobNo) {
      const filter = {}
      filter.conditions = [
        new AdvancedSearchOption(null, 'job.JOB_NO', jobNo, '=').formatObj2Json()
      ]
      filter.branchId = vm.$store.getters.currentOfficeId
      filter.pageNum = 1
      vm.view = 'detail'
      advancedQuery(filter).then(res => {
        const rowData = res.data.list
        if (rowData && rowData.length !== 0) {
          const index = rowData.findIndex(p => p.jobNo === jobNo)
          if (index > 0) {
            vm.$refs.verifyWorkspace.onShow('look', rowData, rowData[index])
          } else {
            vm.$refs.verifyWorkspace.onShow('look', rowData, rowData[0])
          }
        } else {
          vm.$message.error(this.$t('Message.NoRecordMeetTheConditions'))
          vm.$refs.verifyWorkspace.goBack()
        }
      }).catch(() => {
        vm.$message.error(this.$t('Message.JumpFailed'))
      })
    }
  }
}
</script>

<style lang="scss">
</style>
